import { Injectable } from '@angular/core';
import { PopupDialogComponent } from '../shared/popup-dialog/popup-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class DialogMessageService {

  constructor(public dialog: MatDialog) { }

  openMessage(dTitle: string, dMsg: string, cancelable: boolean = false, isError: boolean = false, dWidth: number = 300): MatDialogRef<PopupDialogComponent, any> {
    return this.dialog.open(PopupDialogComponent, {
      data: {
        title: dTitle,
        content: dMsg,
        okText: 'Ok',
        cancelText: 'Cancel',
        showCancel: cancelable,
        isErrorMsg: isError,
        width: dWidth,
      }
    });
  }

  confirmActions(message = 'Do you attest that the selection above is correct?'): MatDialogRef<PopupDialogComponent, any> {
    return this.dialog.open(PopupDialogComponent, {
      data: {
        title: 'Confirm Action',
        content: message,
        okText: 'Yes',
        cancelText: 'No',
        showCancel: true,
        isErrorMsg: false,
        width: 300,
      }
    });
  }

  openErrorMessage(err): MatDialogRef<PopupDialogComponent, any> {
    const message = err.error ? err.error.message : 'Unknown Error';
    return this.dialog.open(PopupDialogComponent, {
      data: {
        title: 'An Error Occurred',
        content: message,
        okText: 'Ok',
        showCancel: false,
        isErrorMsg: true
      }
    });
  }

  InputErrorMessage(): MatDialogRef<PopupDialogComponent, any> {
    return this.dialog.open(PopupDialogComponent, {
      data: {
        title: 'Input Error',
        content: 'Value provided causes the input or a total to exceed the limit of 9,007,199,254,740,991.',
        okText: 'Ok',
        showCancel: false,
        isErrorMsg: true,
        width: 300,
      }
    });
  }

  SubmitErrorMessage(message = 'The submit failed because at least one field on this form is invalid. Locate and fix the problem(s), then try again.'): MatDialogRef<PopupDialogComponent, any> {
    return this.dialog.open(PopupDialogComponent, {
      data: {
        title: 'Invalid Submit',
        content: message,
        okText: 'Ok',
        showCancel: false,
        isErrorMsg: true,
        width: 300,
      }
    });
  }

  //this will exist specifically for azure AD errors because it is an external API and doesn't actually interact with our backend at all.
  azureADUserError() {
    this.dialog.open(PopupDialogComponent, {
      data: {
        title: 'Azure AD - Error',
        content: 'The selected user is not configured to have access to this application. If you are certain this user needs access, please contact GMIT.',
        okText: 'Ok',
        showCancel: false,
        isErrorMsg: true
      }
    });
  }
}
